export { default, type Props as DocumentLinkProps } from './DocumentLink';
